<script setup lang="ts">
import { hatchPatternImg } from "@/hatches/hatch-img";
import type { HatchName } from "@/hatches/hatch-list";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    hatchName?: HatchName;
    rotation?: number;
    size?: number;
  }>(),
  {
    size: 50,
  }
);

const src = computed(() =>
  props.hatchName ? hatchPatternImg[props.hatchName] : undefined
);
</script>

<template>
  <div
    class="hatch-pattern"
    :style="{ height: `${size}px`, width: `${size}px` }"
  >
    <img
      v-if="src"
      :src="src"
      :height="`${size * 2}px`"
      :width="`${size * 2}px`"
      :style="{
        transform: `translate(-25%,-25%) rotate(${rotation}deg)  `,
      }"
    />
  </div>
</template>

<style scoped>
.hatch-pattern {
  display: inline-block;
  overflow: hidden;
  border: 1px solid #ccc;
}
</style>
